import { DateTime } from 'luxon';

export const formatTimestampToLocaleGB = (number) => DateTime.fromMillis(number).toLocaleString({ locale: 'en-gb' })
